import Axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { ThemeContext } from './src/Themes/ThemeContext';
import { CurrentResponseContext } from './src/Utils/Contexts';
import { setBaseUrl } from './src/Utils/Api';
import { ResponseTypes } from './src/Components/FeatureComponents/Response/Constants';
import { getImg } from './src/Utils/getImg';
import CryptoJS from 'crypto-js';
import './assets/css/test.css';
import './assets/css/normalize.css';
import './index.scss';
import {
	getLocationByIP,
	loadStateSession,
	saveState,
	saveStateSession,
} from './src/Components/FlyfishComponents/flyfishutils/utils';
import CacheBuster from 'react-cache-buster';
import { version } from './package.json';
import FractalTheme from './src/Components/FeatureComponents/Flyfish/FractalTheme';
var options = '';
var appNode;

export function encryptText(text) {
	let key = process.env.REACT_APP_SECRET_KEY;
	return btoa(CryptoJS.AES.encrypt(text, key).toString());
}
window.FlyfishChatSDK = function (options = { botID: null }) {
	this.options = options;
	getLocationByIP();
};
var loaderLoginConfig = false;

let AppContainer = (props) => {
	const [currentResponseType, setCurrentResponseType] = React.useState('');
	const isProduction = process.env.NODE_ENV === 'production';
	if (props.data.botName.toLowerCase().indexOf('fractal') > -1) {
		saveStateSession('tenantId', props.tenantID);
		saveStateSession('botId', props.botID);
		saveStateSession('token', props.token);
		saveStateSession('colorMode', props.data.colorMode);
		saveStateSession('botLoggedIn', true);
	}
	return (
		<CacheBuster
			currentVersion={version}
			isEnabled={isProduction} //If false, the library is disabled.
			isVerboseMode={false} //If true, the library writes verbose logs to console.
			metaFileDirectory={'/Fullscreen'} //If public assets are hosted somewhere other than root on your server.
		>
			{props.data.botName.toLowerCase().indexOf('fractal') > -1 ? (
				<ErrorBoundary>
					<FractalTheme {...props} />
				</ErrorBoundary>
			) : (
				<ErrorBoundary>
					<CurrentResponseContext.Provider
						value={{
							typeName: ResponseTypes.SIMPLE,
							setType: setCurrentResponseType,
						}}>
						<App {...props} currentResponseType={currentResponseType} />
					</CurrentResponseContext.Provider>
				</ErrorBoundary>
			)}
		</CacheBuster>
	);
};

function setBackgroundIMG(imageData) {
	var bodyClass = document.getElementsByClassName('toSetBackgroudIMG');
	if (bodyClass.length > 0) {
		const style = bodyClass[0].style;
		style.backgroundImage = `url('${imageData}')`;
		style.height = '100vh';
		style.width = '100vw';
		style.backgroundPosition = '50% 0%';
		style.backgroundRepeat = 'no-repeat';
		style.backgroundSize = 'cover';
		style.overflow = 'hidden';
	}
}

function setBackgroundColor(color) {
	var bodyClass = document.getElementsByClassName('toSetBackgroudIMG');
	if (bodyClass.length > 0 && color) {
		const style = bodyClass[0].style;
		style.backgroundColor = color;
		style.height = '100vh';
		style.width = '100vw';
		style.overflow = 'hidden';
	}
}
function getBotConfig(tenantID, botID, token, flyFishChangesReq) {
	Axios.get(window['BASE_URL'] + `/configuration/${tenantID}/bot/${botID}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'x-tenant-id': tenantID,
		},
	})
		.then((response) => {
			loaderLoginConfig = false;
			var data = response.data.data;
			var channel = loadStateSession('channel');
			getValue(data, 'backgroundType') == 'image'
				? setBackgroundIMG(getValue(data, 'backgroundImage'))
				: setBackgroundColor(getValue(data, 'backgroundColor'));
			let r = document.querySelector(':root');
			r.style.setProperty('--botWidth', 400);
			r.style.setProperty('--botHeight', 100);
			r.style.setProperty(
				'--headerBackground',
				getValue(data, 'headerBackgroundColor') || '#ffffff'
			);
			r.style.setProperty(
				'--headerColor',
				getValue(data, 'headerTextAndIconColor') || '#000000'
			);
			r.style.setProperty(
				'--headerDropdownBorderColor',
				getValue(data, 'headerTextAndIconColor')
					? `${getValue(data, 'headerTextAndIconColor')}33`
					: '#00000033'
			);
			r.style.setProperty(
				'--usrMsgBackground',
				channel === 'whatsapp'
					? '#d9fdd3'
					: getValue(data, 'userMessageBubbleColor') || '#ffffff'
			);
			r.style.setProperty(
				'--usrMsgColor',
				getValue(data, 'userMessageTextColor') || '#000000'
			);
			r.style.setProperty(
				'--inputBackground',
				channel === 'whatsapp'
					? '#fff'
					: getValue(data, 'inputBoxBackgroundColor') ||
							getValue(data, 'userMessageBubbleColor') ||
							'#ffffff'
			);
			r.style.setProperty(
				'--inputBoxColor',
				channel === 'whatsapp'
					? '#000'
					: getValue(data, 'inputBoxTextColor') ||
							getValue(data, 'userMessageTextColor') ||
							'#000000'
			);
			r.style.setProperty('--btnFillBackground', '#ffffff');
			r.style.setProperty(
				'--btnFillColor',
				channel === 'whatsapp' ? '#000' : '#ffffff'
			);
			r.style.setProperty(
				'--outlineBtnColor',
				channel === 'whatsapp'
					? '#000'
					: getValue(data, 'buttonTextAndOutlineColor') ||
							getValue(data, 'userMessageTextColor') ||
							'#000000'
			);
			r.style.setProperty(
				'--optionsBackground',
				getValue(data, 'optionsAndQuickLinksBckColor') ||
					getValue(data, 'aiMessageBubbleColor') ||
					'#383ff6'
			);
			r.style.setProperty(
				'--optionsColor',
				getValue(data, 'optionsAndQuickLinksTextColor') ||
					getValue(data, 'aiMessageTextColor') ||
					'#ffffff'
			);
			r.style.setProperty(
				'--optionsBorder',
				getValue(data, 'optionsAndQuickLinksBorderColor') ||
					`${getValue(data, 'aiMessageTextColor')}66` ||
					'#ffffff66'
			);
			r.style.setProperty(
				'--srvMsgBackground',
				channel === 'whatsapp'
					? '#ffffff'
					: getValue(data, 'aiMessageBubbleColor') || '#383ff6'
			);
			r.style.setProperty(
				'--srvMsgColor',
				channel === 'whatsapp'
					? '#000'
					: getValue(data, 'aiMessageTextColor') || '#ffffff'
			);
			r.style.setProperty('--thumbColor', 'rgba(0,0,0,.6)');
			r.style.setProperty(
				'--thumbBackground',
				getValue(data, 'responseLevelFeedBackBckColor')
					? getValue(data, 'responseLevelFeedBackBckColor')
					: data.srvMsgBackground
					? `${data.srvMsgBackground}CC`
					: '#383ff6CC'
			);
			r.style.setProperty(
				'--thumbBordercolor',
				getValue(data, 'responseLevelFeedBackBorderColor')
					? getValue(data, 'responseLevelFeedBackBorderColor')
					: '#B7B7D800'
			);
			r.style.setProperty(
				'--timeStampBackground',
				getValue(data, 'timeStampBckColor') || '#ffffff99'
			);
			r.style.setProperty(
				'--timeStampColor',
				getValue(data, 'timeStampTextColor') || '#000000cc'
			);
			r.style.setProperty('--fontSize', getValue(data, 'fontSize') || '16px');
			r.style.setProperty(
				'--fontFamily',
				getValue(data, 'fontFamily') || 'Open Sans'
			);
			r.style.setProperty(
				'--backgroundColor',
				getValue(data, 'backgroundColor') ||
					'linear-gradient(to bottom, #ffffff, #cac9fe)'
			);
			r.style.setProperty(
				'--selectedColor',
				getValue(data, 'selectedColor') || '#4800ba'
			);

			r.style.setProperty('--colorMode', getValue(data, 'colorMode'));
			let colorScaleData = JSON.parse(getValue(data, 'colorScale'));
			let hexValues = colorScaleData.map((color) => {
				if (color.startsWith('#')) {
					// Hexadecimal value already present, return as it is
					return color;
				} else {
					// Extract RGB values from the string
					let rgb = color.replace(/^(rgb|rgba)\(/, '').replace(/\)$/, '');
					let [r, g, b] = rgb.split(',');

					// Convert RGB to hexadecimal
					let hex =
						'#' +
						((1 << 24) | ((r << 16) + (g << 8) + Number(b)))
							.toString(16)
							.slice(1);

					return hex;
				}
			});

			for (let i = 0; i < hexValues.length; i++) {
				r.style.setProperty(`--colorScale-${i}`, hexValues[i]);
				r.style.setProperty(`--colorScale-${i}-1f`, hexValues[i] + '1f');
			}
			data = {
				...data,
				isInsideAware: options.isInsideAware ? options.isInsideAware : false,
				isInsideCampaign: options.isInsideCampaign
					? options.isInsideCampaign
					: false,
				isdisableInput: options.isdisableInput ? options.isdisableInput : false,
				primaryColor:
					data.primaryColor && data.primaryColor.length > 0
						? data.primaryColor
						: '#2356a0',
				languages: data.languages || '',
				flyFishChangesReq: options.flyFishChangesReq
					? options.flyFishChangesReq
					: true, // true for flyfish and false for aware
				isInsideKampsta: options.isInsideKampsta
					? options.isInsideKampsta
					: false,
			};
			if (!getValue(data, 'quickLinks')) {
				data.quicklinks = '[]';
			}
			var botName = getValue(data, 'aiName') || 'My AI',
				botWelcomeMessage = getValue(data, 'welcomeMessage'),
				quickLinks =
					getValue(data, 'quickLinks').length > 1 &&
					JSON.parse(getValue(data, 'quickLinks').includes('linkText'))
						? JSON.parse(getValue(data, 'quickLinks'))
						: [],
				botID = botID;

			quickLinks = quickLinks.map((e) => {
				return { actionLabel: e.linkText, actionValue: e.linkValue };
			});
			if (options.isInsideTestPage) {
				if (
					data.userLoginEnabled === 'true' &&
					data.authenticationMechanism === 'sso'
				) {
					data.hideChatBot = true;
					let loginElem = document.getElementById('senseforthLogin');
					loginElem.style.display = 'flex';
					document
						.getElementsByClassName('sf-id-holder')[0]
						.setAttribute('id', data.htmlElementIdForSSO);
				}
			}

			/**
			 * Send botconfig to A.ware
			 */
			if (options.isInsideAware) {
				window.dispatchEvent(
					new CustomEvent('botconfigchange', { detail: data })
				);
			} else {
				/**
				 * Update Document title if not inside A.ware and not integrated bot
				 */
				if (
					window.location.origin.indexOf(window['BASE_URL']) > -1 ||
					window.location.origin.indexOf('localhost') > -1
				) {
					document.title = `${
						data.botNameAsTitle === 'false' ? data.headerTitle : botName
					}`;
					const favicon = document.getElementById('favicon');

					if (favicon) {
						favicon.setAttribute(
							'href',
							!getValue(data, 'avatarImage')
								? getImg('botIcon1.png')
								: getValue(data, 'avatarImage').includes('http')
								? getValue(data, 'avatarImage')
								: window['BASE_URL'] + getValue(data, 'avatarImage')
						);
					}
				}
			}
			let copyData = {
				FAQcontextEnable: '',
				thumbBorderColor: '',
				actionHandlerClass: '',
				thumbColor: 'rgba(0,0,0,.6)', //getValue(data, 'responseLevelFeedBackBckColor'),
				clientPlatform: '',
				DISAMB_MSG_MULTIPLE_OPTIONS: '',
				showBotIcon: getValue(data, 'showAvatar'),
				defaultChitChatModuleDisabled: '',
				disambWorkflowTriggerName: '',
				primaryBGColor: '',
				voiceSupport: '',
				coverImageCheck: '',
				quicklinks: quickLinks,
				languageSplitter: '',
				handOffCount: '',
				isAutoPopupEnabled: getValue(data, 'autoPopupValue'),
				btnFillBackground: getValue(data, 'buttonBckColor'),
				userLoginType: '',
				linkValue: '',
				PrefixNegativeEnabled: '',
				quickLinksOnError: '',
				btnFillColor: getValue(data, 'buttonTextColor'),
				fontSize: getValue(data, 'fontSize'),
				predictiveSearch: '',
				schedulePublicAccess: '',
				relatedQuestions: '',
				headerTitle: getValue(data, 'aiName'),
				workFlowEndMessage: '',
				oauthLogoutApi: '',
				oauthClientId: '',
				timeStampColor: getValue(data, 'timeStampBckColor'),
				pageBackgroundColor: '',
				disambThreshold: '',
				terminateFlowonAPIfail: '',
				optionsBackground: getValue(data, 'optionsAndQuickLinksBckColor'),
				chitChatModuleDisabled: '',
				apiSecretKey: '',
				secondaryBGColor: '',
				cncWorkflowTriggerName: '',
				scheduleToDate: '',
				handOffMessage: '',
				isNotSureTemplateEnabled: '',
				campaignWorkflowQuestion: '',
				botDescription: 'Basic Components Testing Ad',
				indexTimeUpdate: '',
				backgroundColor: getValue(data, 'backgroundColor'),
				userMsgColor:
					getValue(data, 'colorMode') === 'dark'
						? '#ffffff'
						: JSON.parse(getValue(data, 'colorScale'))[0],
				languages: '',
				DISAMB_MSG_ONE_OPTION: '',
				isBotDeployed: '',
				welcomeMessage: getValue(data, 'welcomeMessage'),
				clientCustomerCareEmail: 'demo@demo.com',
				linkText: '',
				clientProvider: '',
				isBotFrozen: '',
				clientBrand: 'CBRAND',
				editOnRequestMessage: '',
				agentSupport: getValue(data, 'agentSupport'),
				multipleIntentEnabled: '',
				maskPIIData: 'true',
				reversecertainThreshold: '',
				tenantId: data.tenantId,
				googleTranslationAPIKey: '',
				optionsBorder: getValue(data, 'optionsAndQuickLinksBorderColor'),
				workflowChangeMessage: '',
				chatBackgroundType: '',
				optionsColor: getValue(data, 'optionsAndQuickLinksTextColor'),
				oauthType: '',
				botfailedMessage: '',
				eB: data.id,
				clientTeam: '',
				clientCustomerCareNumber: '0000000000',
				font: '',
				headerTextColor: '',
				isBotPublic: true,
				autoPopTime: getValue(data, 'autoPopupTime'),
				clientNationality: 'India',
				botImageCheck: '',
				primaryColor: '',
				HandsOffMessage: '',
				timeStampBackground: getValue(data, 'timeStampBckColor'),
				WorkFlowExitMessage: '',
				similarityMatchingLogicEnabled: '',
				notification: '',
				PrefixNeutralEnabled: '',
				tabTitle: '',
				fontFamily: getValue(data, 'fontFamily') || 'Open Sans',
				headerImage: getValue(data, 'headerImage'),
				campaignWorkflowNodeId: '',
				isMultiLingualEnabled: '',
				userObjectApi: '',
				coverImage: getValue(data, 'welcomeBannerImage'),
				scheduleFromDate: '',
				prefixEnabled: '',
				backgroundType: getValue(data, 'backgroundType'),
				multiIntentMessage: '',
				enableChatHistory: '',
				userLoginEnabled: '',
				accentColor: '',
				userMsgBackground:
					getValue(data, 'colorMode') === 'dark'
						? getValue(data, 'selectedColor')
						: JSON.parse(getValue(data, 'colorScale'))[6],
				thumbBackground: getValue(data, 'responseLevelFeedBackBckColor'),
				thumbBordercolor: getValue(data, 'responseLevelFeedBackBorderColor'),
				srvMsgColor: JSON.parse(getValue(data, 'colorScale'))[0],
				chatBackgroundColor: '',
				defaultIcon: '',
				userdetails: '',
				jsonDelimiter: '',
				botType: '',
				isResponseLevelFeedbackEnabled: '',
				headerType: '',
				campaignWorkflow: '',
				showCover: 'true',
				themeConfig: '',
				oauthAuthenticationApi: '',
				StopWordsFlow: '',
				isAutoLangDetectionEnabled: '',
				botNameAsTitle: 'true',
				srvMsgBackground: '#ffffff', //getValue(data, 'aiMessageBubbleColor'),
				botConfigMl: '',
				oauthTokenAPIUrl: '',
				includeHandOffCountForDisamb: '',
				loginSuccessMessage: '',
				notSureTemplates: '[]',
				headerStyle: getValue(data, 'headerIconPosition'),
				backgroundImagePath: '',
				headerColor: getValue(data, 'headerTextAndIconColor'),
				allowOtherLang: '',
				answerQuestionDelimiter: '',
				scope: '',
				botId: data.id,
				loginFailureMessage: '',
				usrMsgColor: getValue(data, 'userMessageTextColor'),
				certainAnswerChangeMessage: '',
				serverMsgColor: getValue(data, 'aiMessageTextColor'),
				headerContentType: getValue(data, 'headerContentType'),
				popComment: '',
				continueAfterAPI: '',
				botImage: getValue(data, 'avatarImage').includes('http')
					? getValue(data, 'avatarImage')
					: window['BASE_URL'] + getValue(data, 'avatarImage'),
				botName: getValue(data, 'aiName'),
				speechSupport: '',
				oauthClientSecret: '',
				fileUploadAPI: '',
				userObjectFields: '',
				outlineBtnColor: getValue(data, 'buttonTextAndOutlineColor'),
				baseURL: '',
				botSkin: '',
				headerContent: '',
				logoImagePath: getValue(data, 'avatarImage').includes('http')
					? getValue(data, 'avatarImage')
					: window['BASE_URL'] + getValue(data, 'avatarImage'),
				certainThreshold: '',
				botWelcomeMessage: getValue(data, 'conversationOpener'),
				headerBackground: getValue(data, 'headerBackgroundColor'),
				usrMsgBackground: getValue(data, 'userMessageBubbleColor'),
				logoImagePathForTitle: '',
				serverMsgBackground: getValue(data, 'aiMessageBubbleColor'),
				secondaryColor: '',
				isShowPersistentMenuEnabled: getValue(data, 'enablePersistentMenu'),
				persistentMenu: getValue(data, 'persistentMenuCustomQuicklinks'),
				isLauncherPromptEnabled: getValue(data, 'aiLaunchPromptCheckbox'),
				launcherPromptMessage: getValue(data, 'aiLaunchPromptText'),
				launcherPromptColor: getValue(data, 'launchPromptTextColor'),
				launcherPromptBackground: getValue(data, 'launchPromptBackgroundColor'),
				botWidth: '400',
				botHeight: '100',
				cardBody: getValue(data, 'cardBody'),
				cardHeading: getValue(data, 'cardHeading'),
				carouselTitle: getValue(data, 'carouselTitle'),
				carouselFieldsData: getValue(data, 'carouselFieldsData'),
				colorScale: JSON.parse(getValue(data, 'colorScale')),
				colorMode: getValue(data, 'colorMode'),
				selectedColor: getValue(data, 'selectedColor'),
				conversationOpener: getValue(data, 'welcomeMessage'),
				workflowData: data.workFlow,
				additionalsettingDetailsCollection: getValue(
					data,
					'additionalsettingDetailsCollection'
				),
				additionalsettingMandatoryCollection: getValue(
					data,
					'additionalsettingMandatoryCollection'
				),
				FSWelcomeHeading: getValue(data, 'FSWelcomeHeading'),
				FSWelcomeSubHeader: getValue(data, 'FSWelcomeSubHeader'),
				FSCarouselFieldsData: getValue(data, 'FSCarouselFieldsData'),
				selectedTheme: getValue(data, 'selectedTheme'),
				enableTrendingSearch: getValue(data, 'enableTrendingSearch'),
				staticDetailsURL: getValue(data, 'staticDetailsURL'),
				showOnHover: getValue(data, 'showOnHover'),
				recommendationHeading: getValue(data, 'recommendationHeading'),
				selectedButton: getValue(data, 'selectedButton'),
				MonacoWelcomeImage: getValue(data, 'MonacoWelcomeImage'),
				EcomChatWelcomeImg: getValue(data, 'E-comChatWelcomeImg'),
				searchEnabled: getValue(data, 'searchEnabled'),
				enableSplashImage:
					getValue(data, 'enableSplashImage') === 'NA'
						? 'false'
						: getValue(data, 'enableSplashImage'),
				'e-comSplashLogo': getValue(data, 'e-comSplashLogo'),
				enableStyleAdvisor:
					getValue(data, 'enableStyleAdvisor') === 'NA'
						? 'false'
						: getValue(data, 'enableStyleAdvisor'),
				advisorTitle: getValue(data, 'advisorTitle'),
				enablePDP: getValue(data, 'enablePDP'),
				enableIntent: JSON.parse(getValue(data, 'Intent_API_Enabled')),
				product_count_per_page: getValue(data, 'product_count_per_page'),
				clientDetails: JSON.parse(getValue(data, 'clientDetails')),
				ecomSearchVertical: getValue(data, 'ecomSearchVertical'),
				ecomSearchDetails: getValue(data, 'ecomSearchDetails'),
			};
			saveStateSession(
				'clientDetails',
				JSON.parse(getValue(data, 'clientDetails'))
			);
			saveStateSession(
				'productCardAspectRatio',
				getValue(data, 'productCardAspectRatio')
			);
			saveStateSession('message_api_url', getValue(data, 'message_api_url'));
			saveStateSession('selectedTheme', getValue(data, 'selectedTheme'));
			saveStateSession(
				'searchBoxPlaceholder',
				getValue(data, 'searchBoxPlaceholder')
			);
			saveStateSession('colorMode', getValue(data, 'colorMode'));

			const linkElement = document.createElement('link');
			linkElement.rel = 'stylesheet';
			linkElement.href = `https://fonts.googleapis.com/css2?family=${copyData.fontFamily}&display=swap`;
			document.head.appendChild(linkElement);
			if (copyData.selectedTheme === 'monaco') {
				const linkToImage = document.createElement('link');
				linkToImage.rel = 'preload';
				linkToImage.fetchPriority = 'high';
				linkToImage.as = 'image';
				linkToImage.href = copyData.MonacoWelcomeImage;
				linkToImage.type = 'image/png';
				linkToImage.className = 'preloading image';
				document.head.appendChild(linkToImage);
			}
			ReactDOM.render(
				<ThemeContext.Provider value={data}>
					<AppContainer
						botName={botName}
						data={copyData}
						botWelcomeMessage={botWelcomeMessage}
						botQuickLinks={quickLinks}
						botID={data.id}
						tenantID={data.tenantId}
						eB={data.id}
						token={token}
						// selectedColor={selectedColor}
					/>
				</ThemeContext.Provider>,
				appNode
			);
			// if (
			// 	error.response.status === 403 ||
			// 	error.response.status === 404 ||
			// 	error.response.status === 424
			// ) {
			// 	ReactDOM.render(
			// 		<div className='center-flex-private'>
			// 			<img src={LockIcon} alt='Private Bot' />
			// 			<span>This bot is private</span>
			// 		</div>,
			// 		appNode
			// 	);
			// }
		})
		.catch((error) => {
			console.log(error);
			loaderLoginConfig = false;
		});
}
function getValue(data, name) {
	let findV = data.botConfig.filter((e) => e.configName == name)[0];
	let value = findV ? findV.value : 'NA';
	if (value == 'True' || value == 'False') {
		value = value.toLowerCase();
	}
	if (value == '[true]') {
		value = true;
	}
	if (value == '[false]') {
		value = false;
	}
	if (value === 'NA' && name === 'message_api_url') {
		return '/messages/';
	}
	return value;
}
function onInit(options) {
	var BASE_URL, CHAT_URL;
	BASE_URL = options['SF_BASE_URL'] || 'https://aware.senseforth.com';
	CHAT_URL = options['SF_CHAT_URL'] || 'https://aware.senseforth.com';
	options = options;
	appNode = document.createElement('div');
	appNode.id = 'sf-chatbot-container';
	var botID = options.botID;
	if (document.getElementById('sf-chatbot-container') == null) {
		if (options.flyFishChangesReq) {
			let chatBotContainer = document.getElementById('sfChatBot');
			chatBotContainer.appendChild(appNode);
		} else {
			document.body.appendChild(appNode);
		}
	} else {
		console.log(
			'A instance of SenseforthChatBot already loaded or DOMNode #sf-chatbot-container exists'
		);
	}

	var date = new Date();
	var timestamp = Math.floor(date.getTime() / 1000.0);
	setBaseUrl(window.location.protocol + '//' + CHAT_URL, options);
	window['BASE_URL'] = BASE_URL;
	window['CHAT_URL'] = CHAT_URL;
	var usertenantID = encryptText(`${options.tenantID}:${timestamp}`);
	loaderLoginConfig = true;
	let searchParams = new URLSearchParams(window.location.search);
	let searchText = searchParams.get('searchText');
	!searchText &&
		Axios.post(
			window['BASE_URL'] + `/authentication/anonynousLogin`,
			{
				name: 'anonymous',
				email: 'anonymousEmail',
				teamId: usertenantID,
			},
			{
				headers: {
					'x-tenant-id': options.tenantID,
				},
			}
		)
			.then((response) => {
				let token = response.data.data.token;
				saveStateSession('tokenExpiry', response.data.data.tokenExpiry);

				saveState('ff_shopify_cook', options.cartCook);
				getBotConfig(
					options.tenantID,
					options.botID,
					token,
					options.flyFishChangesReq
				);
			})
			.catch((err) => {
				loaderLoginConfig = false;
			});
}
FlyfishChatSDK.prototype.init = function () {
	onInit(this.options);
};
